import { SubmissionError } from 'redux-form';

import {
  extractHubURL,
  fetch,
  normalize,
  mercureSubscribe as subscribe
} from '../../utils/dataAccess';
import { success as createSuccess } from './create';
import { error, loading } from './delete';

export function retrieveError(retrieveError) {
  return { type: 'PROCEDURE_UPDATE_RETRIEVE_ERROR', retrieveError };
}

export function retrieveLoading(retrieveLoading) {
  return { type: 'PROCEDURE_UPDATE_RETRIEVE_LOADING', retrieveLoading };
}

export function retrieveSuccess(retrieved) {
  return { type: 'PROCEDURE_UPDATE_RETRIEVE_SUCCESS', retrieved };
}

export function retrieve(id) {
  return dispatch => {
    dispatch(retrieveLoading(true));

    return fetch(id)
      .then(response =>
        response
          .json()
          .then(retrieved => ({ retrieved, hubURL: extractHubURL(response) }))
      )
      .then(({ retrieved, hubURL }) => {
        //retrieved = normalize(retrieved);

        dispatch(retrieveLoading(false));
        dispatch(retrieveSuccess(retrieved));

        if (hubURL) dispatch(mercureSubscribe(hubURL, retrieved['@id']));
      })
      .catch(e => {
        dispatch(retrieveLoading(false));
        dispatch(retrieveError(e.message));
      });
  };
}

export function updateError(updateError) {
  return { type: 'PROCEDURE_UPDATE_UPDATE_ERROR', updateError };
}

export function updateLoading(updateLoading) {
  return { type: 'PROCEDURE_UPDATE_UPDATE_LOADING', updateLoading };
}

export function updateSuccess(updated) {
  return { type: 'PROCEDURE_UPDATE_UPDATE_SUCCESS', updated };
}

export function update(item, values) {
  return (dispatch, getState) => {
    dispatch(updateError(null));
    dispatch(createSuccess(null));
    dispatch(updateLoading(true));

    return fetch(item['@id'], {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/ld+json' }),
      body: JSON.stringify(values)
    })
      .then(response =>
        response
          .json()
          .then(retrieved => ({ retrieved, hubURL: extractHubURL(response) }))
      )
      .then(({ retrieved, hubURL }) => {
        //retrieved = normalize(retrieved);

        dispatch(updateLoading(false));
        // Keep existing procedureSteps so the tree is not replaced by PUT response
        // order (step order is only updated by store_tree).
        const state = getState();
        const procedureUpdate = state.procedure && state.procedure.update;
        const current =
          (procedureUpdate && procedureUpdate.updated) ||
          (procedureUpdate && procedureUpdate.retrieved);
        const sameProcedure =
          current &&
          current['@id'] &&
          retrieved['@id'] &&
          current['@id'] === retrieved['@id'];
        const merged =
          sameProcedure &&
          current.procedureSteps != null &&
          Object.keys(current.procedureSteps).length > 0
            ? { ...retrieved, procedureSteps: current.procedureSteps }
            : retrieved;
        dispatch(updateSuccess(merged));

        if (hubURL) dispatch(mercureSubscribe(hubURL, retrieved['@id']));
      })
      .catch(e => {
        dispatch(updateLoading(false));

        if (e instanceof SubmissionError) {
          // Remove the [nested] member field names and : before an error
          const dotNotationRegex = /((\w*\.*)\w+:)/g;
          const periodNoSpaceRegex = /(\.)(?:\w)/g;
          let error = e.errors._error;
          let formattedError = error
            .replace(dotNotationRegex, '')
            .replace(periodNoSpaceRegex, '. ');
          dispatch(updateError(formattedError));
          return;
        }

        dispatch(updateError(e.message));
      });
  };
}

export function reset(eventSource) {
  return dispatch => {
    if (eventSource) eventSource.close();

    dispatch({ type: 'PROCEDURE_UPDATE_RESET' });
    dispatch(error(null));
    dispatch(loading(false));
    dispatch(createSuccess(null));
  };
}

export function mercureSubscribe(hubURL, topic) {
  return dispatch => {
    const eventSource = subscribe(hubURL, [topic]);
    dispatch(mercureOpen(eventSource));
    eventSource.addEventListener('message', event =>
      //dispatch(mercureMessage(normalize(JSON.parse(event.data))))
      dispatch(mercureMessage(JSON.parse(event.data)))
    );
  };
}

export function mercureOpen(eventSource) {
  return { type: 'PROCEDURE_UPDATE_MERCURE_OPEN', eventSource };
}

export function mercureMessage(retrieved) {
  return dispatch => {
    if (1 === Object.keys(retrieved).length) {
      dispatch({ type: 'PROCEDURE_UPDATE_MERCURE_DELETED', retrieved });
      return;
    }

    dispatch({ type: 'PROCEDURE_UPDATE_MERCURE_MESSAGE', retrieved });
  };
}
